import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "lg:text-lg leading-4 font-semibold text-gray-900" }
const _hoisted_2 = { class: "grid lg:grid-cols-3 sm:grid-cols-2 gap-3 mt-6" }
const _hoisted_3 = { class: "relative flex items-center justify-center" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "absolute right-0 top-0 pr-2 pt-2" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close", -1)
const _hoisted_8 = {
  key: 0,
  class: "flex items-center justify-center"
}
const _hoisted_9 = /*#__PURE__*/_createElementVNode("svg", {
  class: "w-6 animate-spin",
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, [
  /*#__PURE__*/_createElementVNode("circle", {
    class: "opacity-25",
    cx: "12",
    cy: "12",
    r: "10",
    stroke: "currentColor",
    "stroke-width": "4"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    class: "opacity-75",
    fill: "currentColor",
    d: "M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
  })
], -1)
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = {
  key: 1,
  class: "mx-auto w-max"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TrashIcon = _resolveComponent("TrashIcon")!
  const _component_PlusIcon = _resolveComponent("PlusIcon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", null, [
      _createElementVNode("h3", _hoisted_1, _toDisplayString(_ctx.$t("report.sections.gallery.custom_images_title")), 1)
    ]),
    _createElementVNode("input", {
      type: "file",
      onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleFileUpload && _ctx.handleFileUpload(...args))),
      multiple: "",
      enctype: "multipart/form-data",
      accept: ".jpg,.jpeg,.png,.heic, .heif, image/jpeg",
      ref: "imgInput",
      id: "img-imgInput",
      class: "hide-file-input p-o absolute h-1 w-1 overflow-hidden whitespace-nowrap border-0"
    }, null, 544),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image, index) => {
        return (_openBlock(), _createElementBlock("div", { key: index }, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("img", {
              src: image.url,
              alt: "Uploaded Image"
            }, null, 8, _hoisted_4),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("button", {
                type: "button",
                class: "rounded-md bg-gray-50 p-1 text-gray-500 hover:text-red-700",
                onClick: ($event: any) => (_ctx.deleteImage(index))
              }, [
                _hoisted_7,
                _createVNode(_component_TrashIcon, {
                  class: "lg:h-5 h-4",
                  "aria-hidden": "true"
                })
              ], 8, _hoisted_6)
            ])
          ])
        ]))
      }), 128)),
      _createElementVNode("div", null, [
        _createElementVNode("div", {
          class: _normalizeClass([
            'bg-gray-200 rounded-md aspect-h-3 aspect-w-4 flex items-center justify-center object-contain',
            { 'bg-red': _ctx.isDragging },
          ]),
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openFileInput && _ctx.openFileInput(...args))),
          onDragover: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.dragover && _ctx.dragover(...args))),
          onDragleave: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.dragleave && _ctx.dragleave(...args))),
          onDrop: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.drop && _ctx.drop(...args)), ["prevent"]))
        }, [
          (_ctx.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, _hoisted_10))
            : (_openBlock(), _createElementBlock("button", _hoisted_11, [
                _createVNode(_component_PlusIcon, { class: "xl:w-10 xl:h-10 w-5 h-5 hover:text-yellow" })
              ]))
        ], 34)
      ])
    ])
  ]))
}